// @Version: 1.0.1
import { Injectable } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { IFieldItem, ITEMTYPE } from '../../components/field-item/field-item.model';


@Injectable({
   providedIn: 'root'
})

export class ValidatorsService {

   constructor () { }

   public setValidatorsRequired (fieldItem: IFieldItem): ValidatorFn[] {
      return fieldItem.required ? [Validators.required] : [];
   }

   public setValidatorsPattern (fieldItem: IFieldItem): ValidatorFn[] {
      return fieldItem.valid ? [Validators.pattern(`^${<string>fieldItem.valid}$`)] : [];
   }

   public setValidatorsMaxLength (fieldItem: IFieldItem, itemtype?: ITEMTYPE): ValidatorFn[] {
      return fieldItem.attribute_3 ? [Validators.maxLength(+fieldItem.attribute_3)] : [];
   }

   public setValidatorsMinLength(fieldItem: IFieldItem , itemtype?: ITEMTYPE): ValidatorFn[] {
      return fieldItem.attribute_4 ? [Validators.minLength(+fieldItem.attribute_4)] : []
   }

   public setValidators (fieldItem: IFieldItem, itemtype?: ITEMTYPE): ValidatorFn[] {
      switch (itemtype) {
         case ITEMTYPE.combofield: return this.setValidatorsRequired(fieldItem);
         case ITEMTYPE.textInput: return this.setValidatorsRequired(fieldItem).concat(this.setValidatorsMaxLength(fieldItem)).concat(this.setValidatorsMinLength(fieldItem)).concat(this.setValidatorsPattern(fieldItem));
         case ITEMTYPE.email: return this.setValidatorsRequired(fieldItem).concat(Validators.email).concat(this.setValidatorsPattern(fieldItem));
         case ITEMTYPE.textarea: return this.setValidatorsRequired(fieldItem).concat(this.setValidatorsPattern(fieldItem)).concat(this.setValidatorsMaxLength(fieldItem));
         default: return this.setValidatorsRequired(fieldItem);
      }
   }
}
